import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from "@mui/material";
import { useServiceInscripcionCursos } from "hooks/inscripcionCursos/useInscripcionCursos";
import moment from "moment";
import { useEffect } from "react";
import { IconContext } from "react-icons";
import { BsPencilSquare } from "react-icons/bs";

interface CursoProps {
  origen?: string;
}

export const CardCursoVigente = ({ origen }: CursoProps) => {
  const { cursoDisponible, enviado, inscrito, setCursoSeleccionado } =
    useServiceInscripcionCursos();

  const headerCurso = (curso: any) => {
    return (
      <div className="flex gap-2 justify-center items-center">
        <span className="text-sm font-semibold text-gray-700">
          <strong>{curso?.titulo?.toUpperCase()}</strong>
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (enviado) {
      setCursoSeleccionado(null);
    }
  }, [enviado]);

  return (
    <Grid
      xs={12}
      sm={12}
      md={origen === "login" ? 12 : 4}
      lg={origen === "login" ? 12 : 4}
      xl={origen === "login" ? 12 : 4}
      className="mx-auto mt-4"
    >
      {[cursoDisponible]?.map((curso: any) => (
        <div className="w-full">
          <Card>
            <CardHeader
              title={headerCurso(curso)}
              style={{ backgroundColor: "#b9e4f2" }}
            />
            <Divider />
            <CardContent>
              <div className="flex flex-col gap-4">
                <div className="flex flex-row gap-2 items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Fecha de Inicio :{" "}
                    {moment(curso?.fechaInicio).format("DD/MM/YYYY")}
                  </span>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Horario : {curso?.horaInicio} - {curso?.horaFin}
                  </span>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Capacitador : {curso?.capacitador}
                  </span>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Cupo : {curso?.limiteAsistentes}
                  </span>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Lugares disponibles:{" "}
                    {curso?.limiteAsistentes - curso?.inscripciones?.length <= 0
                      ? 0
                      : curso?.limiteAsistentes - curso?.inscripciones?.length}
                  </span>
                </div>
                <div
                  className={
                    Number(curso?.limiteAsistentes) -
                      curso?.inscripciones?.length <=
                    0
                      ? "flex flex-row gap-2 items-center"
                      : "hidden "
                  }
                >
                  <span
                    className="text-sm font-semibold text-gray-700"
                    style={{ color: "red" }}
                  >
                    EL CURSO ESTA LLENO
                  </span>
                </div>
              </div>
            </CardContent>
            <CardActions>
              <Grid
                xs={12}
                sm={12}
                md={origen === "login" ? 12 : 6}
                lg={origen === "login" ? 12 : 6}
                xl={origen === "login" ? 12 : 6}
                className="mx-auto mt-4 py-4"
              >
                <Button
                  type="button"
                  fullWidth
                  className="py-8 mt-4"
                  disabled={origen === "login" ? enviado : inscrito}
                  style={{
                    backgroundColor: "#265ab4",
                    color: "#fff",
                    fontSize: "1rem",
                  }}
                  onClick={() => {
                    setCursoSeleccionado(curso?.idcursotribunal);
                  }}
                  startIcon={
                    <IconContext.Provider value={{ className: "" }}>
                      <BsPencilSquare />
                    </IconContext.Provider>
                  }
                >
                  {origen === "login"
                    ? enviado
                      ? "Inscrito"
                      : "Inscribirse"
                    : inscrito
                    ? "Inscrito"
                    : "Inscribirse"}
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </div>
      ))}
    </Grid>
  );
};
